// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ec-f","alertIcon":"ConfirmModal_alertIcon__O0ftW"};